export default __webpack_public_path__ + "static/media/about_3.d1598f46.png";